/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadybadgecopied3Inputs */

const en_searchreadybadgecopied3 = /** @type {(inputs: Searchreadybadgecopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code copied`)
};

const de_searchreadybadgecopied3 = /** @type {(inputs: Searchreadybadgecopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopiert`)
};

/**
* | output |
* | --- |
* | "Code copied" |
*
* @param {Searchreadybadgecopied3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadybadgecopied3 = /** @type {((inputs?: Searchreadybadgecopied3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadybadgecopied3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadybadgecopied3(inputs)
	return de_searchreadybadgecopied3(inputs)
});
export { searchreadybadgecopied3 as "searchReadyBadgeCopied" }